import { precipitationTypes } from '../gma-mapping';
import { isNil } from 'src/utils/utils';

export const transformWebcamUrl = (urlIn: string): string => {
  const prefix = 'https://s3-eu-west-1.amazonaws.com/';
  const manufacturer = urlIn.substr(
    7,
    urlIn.indexOf('.s3-website-eu-west-1.amazonaws.com') - 7
  );
  const subdir = urlIn.indexOf('/webcam/') > 0 ? '/webcam/' : '/new/';
  const jpg = urlIn.substr(urlIn.indexOf(subdir) + subdir.length);
  const urlOut = prefix + manufacturer + subdir + jpg;
  return urlOut;
};

export const getCleanedWW = (ww: number): number => {
  const blackList = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 19, 28, 30, 31, 32, 33,
    34, 35, 42, 43, 44, 45, 45, 46, 47, 48, 49, 100, 101, 102, 103, 104, 105,
    110, 111, 112, 118, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130,
    131, 132, 133, 134, 135, 199, 204, 206, 207, 208, 209, 210, 211, 219, 220,
    221, 222, 223, 224, 225, 226, 227, 228, 230, 239, 241, 242, 243, 244, 245,
    246, 247, 248, 249,
  ];
  // if (ww < 11 || ww > 293 || (ww > 99 && ww < 104)) {
  if (blackList.indexOf(ww) >= 0 || ww > 293) {
    return null;
  }
  return ww;
};

export const gmaPrecipitationTypeMapping = (
  value: number,
  stationSource
): string => {
  let returnValue = 'MAPPING.GMA_DWD_PRECTYPE.';
  if (isNil(value)) {
    return returnValue + '7';
  }
  return returnValue + value;
};

export const colSpan = (
  i: number,
  parameterGroup: string,
  parameterGroups: any
): number => {
  return i === 0 && parameterGroups[parameterGroup].length < 2 ? 2 : 1;
};

export const gmaPrecipitationTypeMapping1 = (
  value: number,
  stationSource
): string => {
  const returnValue =
    stationSource === '2' ? 'MAPPING.GMA_DWD_PRECTYPE.' : 'MAPPING.WW.';

  if (!value || value === 0) {
    return returnValue + 'NO_PRECIPITATION';
  }

  if (stationSource === '3') {
    if (value < 1) {
      return 'MAPPING.GMA_DWD_PRECTYPE.NO_PRECIPITATION';
    } else {
      return returnValue + value;
    }
  }

  if (precipitationTypes.hasOwnProperty(value)) {
    return returnValue + precipitationTypes[value];
  }
  const bits = value.toString(2);
  const allPrecipitations = [];
  for (let i = 0; i < 30; i++) {
    if (bits[i] === '1') {
      allPrecipitations.push(precipitationTypes[i + 1]);
    }
  }
  return returnValue + allPrecipitations.join(',');
};

export const getGmaAlarmColor = (stationDataByAlarmParameter: any) => {
  return gmaAlarmColors[stationDataByAlarmParameter];
};

export const gmaAlarmColors = {
  S: '#f9715f',
  E: '#e14b7e',
  N: '#373f43',
  R: '#9e9e9e',
  B: '#bbdefb',
  0: 'transparent',
};

export const getColor = (
  data: any,
  parameter: string,
  greenTableDesign: boolean
): string => {
  if (parameter === 'tt') {
    if (data.hasOwnProperty(parameter)) {
      return colorMappingTT(data[parameter], greenTableDesign);
    }
  } else if (parameter === 'road_tt') {
    for (const param of ['road_tt', 'road_tt2', 'road_tt3']) {
      if (data.hasOwnProperty(param)) {
        return colorMappingTT(data[param], greenTableDesign);
      }
    }
  } else if (parameter === 'road_condition') {
    for (const param of [
      'road_condition',
      'road_condition2',
      'road_condition3',
    ]) {
      if (data.hasOwnProperty(param)) {
        return colorMappingCond(data[param], greenTableDesign);
      }
    }
  }
  return '';
};

export const colorMappingTT = (
  value: number,
  greenTableDesign: boolean
): string => {
  let color = greenTableDesign ? 'table-green' : '';

  if (!value && value !== 0) {
    return color;
  }
  if (value <= 0.05) {
    color = 'smw-tt-0';
  } else if (value <= 1.04) {
    color = 'smw-tt-1';
  } else if (value <= 3.04) {
    color = 'smw-tt-3';
  } else if (value <= 23.04) {
    color = greenTableDesign ? 'table-green' : 'smw-tt-23';
  } else if (value <= 25.04) {
    color = 'smw-tt-25';
  } else if (value <= 30.04) {
    color = 'smw-tt-30';
  } else if (value <= 35.04) {
    color = 'smw-tt-35';
  } else if (value <= 40.04) {
    color = 'smw-tt-40';
  } else {
    color = 'smw-tt-100';
  }
  return color;
};

export const colorMappingCond = (
  value: number,
  greenTableDesign: boolean
): string => {
  let color = greenTableDesign ? 'table-green' : '';
  if (!value) {
    return color;
  }
  if (value <= 1) {
    // color = color;
  } else if (value <= 2) {
    color = 'cond-moist';
  } else if (value <= 3) {
    color = 'cond-nass';
  } else if (value < 999) {
    color = 'table-danger';
  }
  return color;
};

export const colorMappingPigeon = (
  parameter: string,
  value: number
): string => {
  return '';
  switch (parameter) {
    case 'tt':
      if (value > 6) return 'table-green';
      else if (value > 4 && value <= 6) return 'table-warning';
      else if (value > 2 && value <= 4) return 'table-orange';
      else if (value > 0 && value <= 2) return 'table-danger';
      else if (value <= 0) return 'table-purple';
      else return '';
    case 'td':
      if (value < 16) return 'table-green';
      else if (value >= 16 && value < 18) return 'table-warning';
      else if (value >= 18 && value < 20) return 'table-orange';
      else if (value >= 20 && value < 22) return 'table-danger';
      else if (value >= 22) return 'table-purple';
      else return '';
    case 'rh':
      if (value < 75) return 'table-green';
      else if (value >= 75 && value < 80) return 'table-warning';
      else if (value >= 80 && value < 85) return 'table-orange';
      else if (value >= 85 && value < 90) return 'table-danger';
      else if (value >= 90) return 'table-purple';
      else return '';
    case 'ff':
    case 'fx':
      // Beaufort scale
      if (value <= 49) return 'table-green';
      else if (value > 49 && value <= 61) return 'table-warning';
      else if (value > 61 && value <= 74) return 'table-orange';
      else if (value > 74 && value <= 88) return 'table-danger';
      else if (value > 88) return 'table-purple';
      else return '';
    case 'vv':
      if (value >= 10000) return 'table-green';
      else if (value < 10000 && value >= 5000) return 'table-warning';
      else if (value < 5000 && value >= 2000) return 'table-orange';
      else if (value < 2000 && value >= 1000) return 'table-danger';
      else if (value < 1000) return 'table-purple';
      else return '';
    case 'hcl':
      if (value >= 1000) return 'table-green';
      else if (value < 1000 && value >= 500) return 'table-warning';
      else if (value < 500 && value >= 200) return 'table-orange';
      else if (value < 200 && value >= 100) return 'table-danger';
      else if (value < 100) return 'table-purple';
      else return '';
    case 'humidityIndex':
    case 'inversionIndex':
      if (value === 0) return 'table-green';
      else if (value === 1) return 'table-warning';
      else if (value === 2) return 'table-orange';
      else if (value === 3) return 'table-danger';
      else if (value === 4) return 'table-purple';
      else return '';
    default:
      return '';
  }
};

export const getMarkerColorClass = (
  parameter: string,
  value: number,
  isPigeonCustomer: boolean,
  smwServiceGreenTableDesign: boolean
): string => {
  if (isPigeonCustomer) {
    return colorMappingPigeon(parameter, value);
  } else {
    if (
      parameter.indexOf('tt') >= 0 ||
      parameter === 't5' ||
      parameter.indexOf('tg') === 0
    ) {
      return colorMappingTT(value, smwServiceGreenTableDesign);
    }
    if (parameter.indexOf('road_condition') >= 0) {
      return colorMappingCond(value, smwServiceGreenTableDesign);
    }
  }
  return '';
};

export const MAP_TAB_INDEX = 1;
